const WEBHOOK_URL = 'https://hook.eu2.make.com/m5hyrlbxrp1estn5204iovb8ndncfdyg'

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'gclid',
  'fbclid',
  'ttclid',
] as const

const STORAGE_KEY = 'hsg-tracking-params'

export type TrackingParams = Record<string, string>

/**
 * Liest die UTM-/Klick-Parameter aus der URL und merkt sie sich für die Session,
 * damit sie auch dann noch mitgeschickt werden, wenn die Besucherin vorher
 * durch mehrere Seiten navigiert hat.
 */
export function getTrackingParams(): TrackingParams {
  if (typeof window === 'undefined') return {}

  let stored: TrackingParams = {}
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    if (raw) stored = JSON.parse(raw) as TrackingParams
  } catch {
    stored = {}
  }

  const fromUrl: TrackingParams = {}
  const search = new URLSearchParams(window.location.search)
  UTM_KEYS.forEach((key) => {
    const value = search.get(key)
    if (value) fromUrl[key] = value
  })

  const merged = { ...stored, ...fromUrl }

  if (Object.keys(fromUrl).length > 0) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
    } catch {
      /* Speicher nicht verfügbar – Parameter werden trotzdem mitgeschickt. */
    }
  }

  return merged
}

export type LeadPayload = {
  firstName: string
  email: string
  countryCode: string
  whatsapp: string
}

export async function submitLead(payload: LeadPayload): Promise<void> {
  const tracking = getTrackingParams()

  const body = {
    ...payload,
    phone: `${payload.countryCode}${payload.whatsapp.replace(/[^0-9]/g, '')}`,
    ...tracking,
    utm: tracking,
    pageUrl: typeof window !== 'undefined' ? window.location.href : '',
    referrer: typeof document !== 'undefined' ? document.referrer : '',
    submittedAt: new Date().toISOString(),
  }

  const response = await fetch(WEBHOOK_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    throw new Error(`Webhook responded with ${response.status}`)
  }
}
